import React, { TextareaHTMLAttributes } from 'react'
import clsx from 'clsx'

type Props = {
  height?: 'sm' | 'md'
  error?: boolean
} & TextareaHTMLAttributes<HTMLTextAreaElement>

const FormTextarea: React.FC<Props> = React.forwardRef<HTMLTextAreaElement, Partial<Props>>(
  ({ height = 'md', error = false, ...props }, ref) => (
    <textarea
      ref={ref}
      className={clsx(
        props.className,
        height === 'sm' && 'h-20',
        height === 'md' && 'h-32',
        'block w-full border p-3 text-sm leading-none focus:outline-none',
        'resize-none rounded-lg border-gray-300 text-gray-800 placeholder-gray-400 focus:ring-2 focus:ring-gray-100',
        error && 'border-red-600'
      )}
      {...props}
    />
  )
)

FormTextarea.displayName = 'FormTextarea'

export default FormTextarea
